/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import GroupResponse from './GroupResponse';
import Options from './Options';

/**
* The GetGroupResponse model module.
* @module model/GetGroupResponse
* @version 2020-12-7
*/
export default class GetGroupResponse {
    /**
    * Constructs a new <code>GetGroupResponse</code>.
    * グループ取得レスポンス
    * @alias module:model/GetGroupResponse
    * @class
    * @param group {module:model/GroupResponse} 
    * @param result {module:model/GetGroupResponse.ResultEnum} 
    */

    constructor(group, result) {
        
        
        this['group'] = group;
        this['result'] = result;
        
    }

    /**
    * Constructs a <code>GetGroupResponse</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/GetGroupResponse} obj Optional instance to populate.
    * @return {module:model/GetGroupResponse} The populated <code>GetGroupResponse</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new GetGroupResponse();
                        
            
            if (data.hasOwnProperty('group')) {
                obj['group'] = GroupResponse.constructFromObject(data['group']);
            }
            if (data.hasOwnProperty('result')) {
                obj['result'] = ApiClient.convertToType(data['result'], 'String');
            }
            if (data.hasOwnProperty('options')) {
                obj['options'] = Options.constructFromObject(data['options']);
            }
        }
        return obj;
    }

    /**
    * @member {module:model/GroupResponse} group
    */
    'group' = undefined;
    /**
    * @member {module:model/GetGroupResponse.ResultEnum} result
    */
    'result' = undefined;
    /**
    * @member {module:model/Options} options
    */
    'options' = undefined;



    /**
    * Allowed values for the <code>result</code> property.
    * @enum {String}
    * @readonly
    */
    static ResultEnum = {
        /**
         * value: "NG"
         * @const
         */
        "NG": "NG",
        /**
         * value: "OK"
         * @const
         */
        "OK": "OK"    };

}
